import { type SelectRootSlotProps } from '@mui/base'
import { clsx } from 'clsx'
import { type JSX } from 'react'

import { SelectRoot } from 'base-ui'

import styles from './ProductSearchRefinementRoot.module.css'

export const ProductSearchRefinementRoot = <
  OptionValue extends NonNullable<unknown>,
  Multiple extends boolean,
>(
  props: SelectRootSlotProps<OptionValue, Multiple>,
): JSX.Element => {
  const { className, ...rootProps } = props

  return (
    <SelectRoot
      className={clsx(className, styles['product-search-refinement-root'])}
      {...rootProps}
    />
  )
}
